// Supprimer les avertissements defaultProps de react-beautiful-dnd - DOIT ÊTRE EN PREMIER
import "src/utils/suppressWarnings";
import "src/i18n";

import React from "react";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.css";
import "src/assets/css/fontawesome.generated.css";
import "src/assets/css/index.css";
import App from "src/App";
import "src/assets/css/userLayout.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root was not found");
}
const root = createRoot(rootElement);

root.render(
  <>
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={true}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="dark"
      style={{
        width: "fit-content",
      }}
    />
    <App />
  </>,
);
